import { useQuery, useQueryClient } from '@tanstack/react-query';
import { fetchMe, logout as apiLogout } from '../lib/auth';
import type { MeResponse } from '@shared/types';

const ME_KEY = ['me'] as const;

export function useAuth() {
  const qc = useQueryClient();
  const query = useQuery<MeResponse | null>({
    queryKey: ME_KEY,
    queryFn: fetchMe,
    staleTime: 60_000,
  });

  const user = query.data?.user ?? null;

  return {
    user,
    isAdmin: user?.role === 'admin',
    isLoading: query.isLoading,
    refresh: () => qc.invalidateQueries({ queryKey: ME_KEY }),
    logout: async () => {
      await apiLogout();
      qc.setQueryData(ME_KEY, null);
    },
  };
}
